import axios from "axios";
import { useMemo } from "react";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const fileUrl = (p) => (p ? `${API}/files/${p}` : null);
export const fmt = (n) => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(n || 0);
export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" }) : "");
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("tr-TR") : "");
export const todayStr = () => new Date().toLocaleDateString("sv-SE");

export const SUPPORT_PHONE = "0542 396 12 60";
export const SUPPORT_TEL = "tel:+905423961260";
export const SUPPORT_WA = "https://wa.me/905423961260?text=" + encodeURIComponent("Merhaba, Gazi Sepet hakkında bilgi almak istiyorum.");
export const ANNUAL_PRICE = "6.000 TL";

export const SOURCES = {
  telefon: "Telefon", gel_al: "Gel-Al", masa: "Masa", qr: "QR Menü",
  yemeksepeti: "Yemeksepeti", trendyol: "Trendyol Go Yemek", migros: "Migros Yemek",
};
export const SOURCE_COLORS = {
  telefon: "bg-sky-100 text-sky-800", gel_al: "bg-slate-100 text-slate-700", masa: "bg-emerald-100 text-emerald-800",
  qr: "bg-violet-100 text-violet-800", yemeksepeti: "bg-[#EA002A] text-white", trendyol: "bg-[#F27A1A] text-white", migros: "bg-[#FF6000] text-white",
};
export const PAYMENTS = { nakit: "Nakit", pos: "POS Cihazı", kredi_karti: "Kredi Kartı" };
export const STATUSES = { yeni: "Yeni", hazirlaniyor: "Hazırlanıyor", yolda: "Yolda", teslim: "Teslim Edildi", iptal: "İptal" };
export const PLATFORM_INFO = {
  yemeksepeti: { name: "Yemeksepeti", color: "#EA002A", letter: "Y" },
  trendyol: { name: "Trendyol Go Yemek", color: "#F27A1A", letter: "T" },
  migros: { name: "Migros Yemek", color: "#FF6000", letter: "M" },
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || e?.message || "Bir hata oluştu";
};

export const LOCAL_TOKEN_KEY = "gs_auth_token";
export const getLocalToken = () => localStorage.getItem(LOCAL_TOKEN_KEY);

// Yerel JWT (e-posta+şifre) Authorization başlığıyla gönderilir; Clerk oturumu varsa
// __session tanımlama bilgisi aynı-origin isteklerde otomatik gider.
export function useApi() {
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use(async (cfg) => {
      const local = getLocalToken();
      if (local) cfg.headers.Authorization = `Bearer ${local}`;
      return cfg;
    });
    return inst;
  }, []);
}

export const headerApi = (header, value) => axios.create({ baseURL: API, headers: value ? { [header]: value } : {} });
